const Authority = () => {
  return (
    <div className="hero-authority-container">
      <div className="hero-authority-item">
        <img
          src="https://res.cloudinary.com/malidad/image/upload/v1777961503/10-years-black-icon_rupvf9.svg"
          alt="Handshake Icon"
          className="10 years icon"
        />
        <div>
          <p className="authority-title boldTitle ntuna-text-fill">
            10+ <span className="authority-span-text">Years</span>
          </p>
          <span className="authority-desc">Proven Track Record</span>
        </div>
      </div>
      <div className="hero-authority-item middle">
        <img
          src="https://res.cloudinary.com/malidad/image/upload/v1777961504/task-checkmark_xmxj6y.svg"
          alt="Projects completed"
          className="authority-icon"
        />
        <div>
          <p className="authority-title boldTitle ntuna-text-fill">
            500+ <span className="authority-span-text">Projects</span>
          </p>
          <span className="authority-desc">Worldwide Since 2017</span>
        </div>
      </div>
      <div className="hero-authority-item">
        <img
          src="https://res.cloudinary.com/malidad/image/upload/v1777961503/outsourcing-icon_rvnb2x.png"
          alt="Staff"
          className="authority-icon"
        />
        <div>
          <p className="authority-title boldTitle ntuna-text-fill">
            50+ <span className="authority-span-text">Pro Staff</span>
          </p>
          <span className="authority-desc">In 3 countries</span>
        </div>
      </div>
    </div>
  );
};

export default Authority;
